module.exports = __webpack_public_path__ + "img/logo_solid.3cf440cb.svg";